import moment from "moment";
import "moment/min/locales";

const getMomentLocale = (locale) => {
  if (!locale) return 'en';

  const normalizedLocale = locale.toLowerCase();
  const languageLocale = normalizedLocale.split('-')[0];
  const momentLocales = moment.locales();

  if (momentLocales.includes(normalizedLocale)) {
    return normalizedLocale;
  }

  return momentLocales.includes(languageLocale) ? languageLocale : 'en';
};

const getLocalizedFormat = format => {
  if (!format) return 'L';
  if (/^[MDY/\-\s]+$/.test(format)) return 'L';
  if (format.includes('MMMM')) return format.includes('ddd') ? 'ddd LL' : 'LL';
  if (format.includes('MMM')) {
    if (format.includes('YYYY')) return format.includes('ddd') ? 'ddd ll' : 'll';
    return 'D MMM';
  }
  return format;
};

const formatWithLocale = (date, locale, format, useUtc = false) => {
  if (!date) return '';

  const momentLocale = getMomentLocale(locale);
  const isTimestamp = typeof date === 'number' || /^\d{10,}$/.test(String(date));
  const localizedDate = (useUtc ? (isTimestamp ? moment(Number(date)).utc() : moment.utc(date)) : moment(date))
    .locale(momentLocale);
  const formattedDate = localizedDate.format(getLocalizedFormat(format));
  const localeData = moment.localeData(momentLocale);

  return localeData.preparse ? localeData.preparse(formattedDate) : formattedDate;
};

export const formatLocalizedPaymentDate = (date, locale, format) => {
  return formatWithLocale(date, locale, format);
};

export const formatLocalizedDate = (date, locale, format) => {
  return formatWithLocale(date, locale, format, true);
};
